module.exports = __webpack_public_path__ + "img/md-item03.d7411c6.png";